import { createStore } from '@oneappexchange/lwc-wired';
import { State } from 'zustand';
import { IS_DEVELOPMENT } from '~/modules/config';
import { getSearchTermSuggestions, Suggestion } from '../services/searchService';

export interface searchTermSuggestionState extends State {
    searchTermSuggestions: Map<string, Suggestion[]>;
}

const initialState: searchTermSuggestionState = {
    searchTermSuggestions: new Map<string, Suggestion[]>(),
};

export const selectSearchTermSuggestions = (state: searchTermSuggestionState, keyword: string) => {
    return state.searchTermSuggestions.get(keyword);
};

export const searchTermSuggestionStore = createStore(
    initialState,

    (set: SetState<searchTermSuggestionState>, get: GetState<searchTermSuggestionState>) => ({
        async fetchSearchTermSuggestions(keyword: string) {
            const existingSearchTermSuggestions = selectSearchTermSuggestions(get(), keyword);
            const noPreviousSuggestions = !existingSearchTermSuggestions || existingSearchTermSuggestions.length === 0;
            if (noPreviousSuggestions) {
                const suggestionResult = await getSearchTermSuggestions(keyword);
                set(function updateSearchResults(draft: searchTermSuggestionState) {
                    draft.searchTermSuggestions.set(keyword, suggestionResult.suggestions);
                });
            }
        },
        reset() {
            set(function resetStore() {
                return initialState;
            });
        },
    }),
    'searchTermSuggestionStore',
    IS_DEVELOPMENT,
);
